import { orchestrator } from 'satcheljs';
import { onCopilotChatDrawerLayoutChange } from 'owa-copilot-chat-drawer-store';
import isFlexPaneShownHelper from 'owa-app-pane-group-utils/lib/helpers/isFlexPaneShownHelper';
import calculateAvailableWidthBucket from '../utils/calculateAvailableWidthBucket';
import { getAreDisplayAdsEnabled } from '../selectors/getAreDisplayAdsEnabled';
import { setBrowserWidthBucket } from '../actions/setAvailableHeightAndWidthBuckets';
import { onAvailableWidthBucketChanged } from '../actions/onAvailableWidthBucketChanged';
import LayoutChangeSource from '../store/schema/LayoutChangeSource';
import { isFeatureEnabled } from 'owa-feature-flags';
import { safeRequestAnimationFrame } from 'owa-performance';

/**
 * Helper function to handle layout width changes.
 * This functions calls the appropriate mutators and actions to
 * update the layout based on a width change.
 */
orchestrator(onCopilotChatDrawerLayoutChange, () => {
    if (isFeatureEnabled('mon-copilot-bizchat-fix-loafs')) {
        safeRequestAnimationFrame(() => {
            updateBrowserWidthBucket();
        });
    } else {
        updateBrowserWidthBucket();
    }
});

const updateBrowserWidthBucket = () => {
    const newAvailableWidthBucket = calculateAvailableWidthBucket(
        false /* skipCache */,
        getAreDisplayAdsEnabled(),
        isFlexPaneShownHelper()
    );
    setBrowserWidthBucket(newAvailableWidthBucket);
    onAvailableWidthBucketChanged(newAvailableWidthBucket, LayoutChangeSource.CopilotChatDrawer);
};
